<div *ngIf="success">Votre compte a été activé, vous pouvez désormais utiliser le bouton de connexion dans la barre d'outils</div>
<div *ngIf="error">Erreur, inscription invalide (le lien n'est plus valide ?)</div>